import ReactDOM from 'react-dom';

import { documentReady } from '@omq/shared';

import { App } from '@admin/shared/components/module/app';
import { ReactElement } from 'react';

/**
 * Type of function props.
 */
type InitModuleProps = {
  renderModule: () => ReactElement<typeof App>;
  moduleName: string;
};
/**
 * Get module from passed render function, and add
 * module to app placeholder.
 *
 * Catch errors and report to sentry.
 *
 * TODO: setup new sentry app.
 *
 * @param {Function} renderModule - function to init module
 * @param {string} moduleName - name of the module
 */

export const initModule: (props: InitModuleProps) => void = ({ renderModule, moduleName }) => {
  documentReady().then(() => {
    try {
      const element = document.getElementById('app');
      const moduleComponent = renderModule();

      if (element == null) {
        throw new Error(`App element not found. Can not render module ${moduleName}`);
      }

      ReactDOM.render(moduleComponent, element);
    } catch (error) {
      console.error(`Error in module ${moduleName}`, error);

      // catch unhandled errors from application
      // ErrorHandling.captureException(error, null, DSN);
    }
  });
};
